import BaseElement from './BaseElement';
import TableBuilder from "@frontend/group/modules/simple-table-builder/builder/index";

export default class TableRow extends BaseElement {

  cells = [];

  constructor(cells = []) {
    super();

    this.cells = cells;
  }

  setCells(cells) {
    this.cells = cells;
  }

  addCell(cell) {
    this.cells.push(cell);
  }

  /**
   * @param {boolean} tableColumnMode
   */
  async toHTML(tableColumnMode = false, truncateLongText = false) {
    const cells = await Promise.all(this.cells.map(/** @param {TableCell} cell */ async cell => await cell.toHTML(tableColumnMode, truncateLongText)))

    return `<tr ${this.getStyleAttribute(tableColumnMode)}>${cells.join('')}</tr>`;
  }

  /**
   * @param {boolean} tableColumnMode
   */
  toData(tableColumnMode = false) {
    return {
      id: this.id,
      stringStyles: this.styles.getStyle(tableColumnMode),
      styles: this.styles,
      cells: this.cells.map(/** @param {TableCell} cell */ cell => cell.toData(tableColumnMode))
    }
  }
}
